export default {
      id: "epro-close-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#epro-close",
      toString: function () {
        return this.url;
      }
    }